import { render, staticRenderFns } from "./CTFBandit.vue?vue&type=template&id=bd206a4e&scoped=true&"
import script from "./CTFBandit.vue?vue&type=script&lang=js&"
export * from "./CTFBandit.vue?vue&type=script&lang=js&"
import style0 from "./CTFBandit.vue?vue&type=style&index=0&id=bd206a4e&lang=sass&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bd206a4e",
  null
  
)

export default component.exports